import { IncreaseAllocationModal } from '@decub8/ui';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';

import { Content, Meta, ProjectComponent } from '@src/components';
import { CONTENT } from '@src/config';
import { DEFAULT_IDO_ROUND_DURATIONS } from '@src/constants';
import { useAllocationModal } from '@src/hooks/pages/useAllocationModal';
import { ProjectProps } from '@src/ts/props';
import { generateSlug } from '@src/utils/format';
import { getProjectData } from '@src/utils/getters';

const ProjectEventPage: React.FC<ProjectProps> = ({ project }) => {
    const router = useRouter();
    const props = useAllocationModal();

    return (
        <Content>
            <Meta
                title={project.name}
                description={project.description}
                current_url={router.asPath}
                image_url={project.hero}
            />
            <ProjectComponent project={project} />
            {CONTENT.companyName.toLowerCase().includes('decubate') && (
                <IncreaseAllocationModal {...props} />
            )}
        </Content>
    );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
    const { project_slug, event_slug } = context.query;

    try {
        const project = await getProjectData(project_slug as string);

        const events = project.events?.filter(
            (e) => event_slug === generateSlug(e.name),
        );

        // TODO: do not delete, this is for testing an event with very quick rounds
        // const updated_events = events.map((event) => {
        //     // if (!event.event_details?.durations) {
        //     return {
        //         ...event,
        //         // temporary
        //         start_date: dayjs().unix().toString(),
        //         event_details: {
        //             ...(event.event_details || {}),
        //             // temporary
        //             durations: [15, 15, 15],
        //             // durations: DEFAULT_IDO_ROUND_DURATIONS,
        //         },
        //     };
        // });

        const updated_events = events.map((event) => {
            if (!event.event_details?.durations) {
                return {
                    ...event,
                    event_details: {
                        ...(event.event_details || {}),
                        durations: DEFAULT_IDO_ROUND_DURATIONS,
                    },
                };
            }
            return event;
        });

        return {
            props: {
                errors: [],
                project: {
                    ...project,
                    events: updated_events,
                },
            },
        };
    } catch (e) {
        console.log('Error', e.graphQLErrors);
        return {
            props: {
                errors: [e.message],
                project: null,
                tiers: [],
            },
        };
    }
};

export default ProjectEventPage;
